import { ref } from 'vue';
import { getConfig } from '../../config';

export default function useDomainConfig() {
    const baseUrl = process.env.VUE_APP_DOMAIN || window.location.origin;
    const domainConfig = getConfig(baseUrl) || {};
    const logo = ref(domainConfig.logo || '@/assets/images/default-logo.png');
    const impressumUrl = ref(domainConfig.impressum || 'https://www.apcoa.de/ueber-apcoa/unternehmen/impressum/');
    const datenschutzUrl = ref(domainConfig.datenschutz || 'https://www.apcoa.de/datenschutzerklaerung/');
    const companyName = ref(domainConfig.companyName || 'APCOA Deutschland GmbH');
    const faqURL = ref(domainConfig.faqURL || '/');
    const violationText1= ref(domainConfig.violationText1 || 'Die Park & Control PAC Austria GmbH wird immer dann beauftragt wenn auf privaten Parkflächen nicht genügend Stellplätze für Kunden, Mitarbeiter etc. zur Verfügung stehen oder wenn die Stellplätze aufgrund Fremd- und/oder Dauerparker blockiert sind. Die Park & Control PAC Austria GmbH prüft auf Grundlage der vor Ort gültigen AGB (allgemeine Geschäftsbedingungen), ob ein Fahrzeug länger als die mit dem Auftraggeber abgestimmte Höchstparkdauer parkt. Ist dies der Fall, stellt die Park & Control PAC Austria GmbH auf der rechtlichen Grundlage der vor Ort ausgehängten AGB eine Vertragsstrafe aus.');
    const violationText2= ref(domainConfig.violationText2 || 'Die Park & Control PAC Austria GmbH wird immer dann beauftragt, wenn auf privaten Parkflächen nicht genügend Stellplätze für Kunden, Mitarbeiter, Mieter, Patienten etc zur Verfügung stehen, weil diese Stellplätze durch unberechtigte Fremd- und Dauerparker blockiert werden. Auf diesen Parkflächen gelten die Allgemeinen Geschäftsbedingungen (AGB) der Park & Control PAC Austria GmbH. Auf deren Grundlage prüft die Park & Control PAC Austria GmbH, ob eine Berechtigung zum Parken des jeweiligen Fahrzeuges (z.B. in Form einer Parkscheibe, eines Parkscheins oder einer sonstigen Parkberechtigung) vorliegt. Ist dies nicht der Fall, stellt die Park & Control PAC Austria GmbH auf der rechtlichen Grundlage der jeweils vor Ort aushängenden AGB eine Vertragsstrafe aus.');
    const currency = ref(domainConfig.currency || '€');
    const bankDetails = ref(domainConfig.bankDetails || {
        companyName: 'APCOA Deutschland GmbH',
        companyIban: 'DE60600700700148591100',
        companyBic: 'DEUTDESSXXX'
    });

 
    return {
        logo,
        impressumUrl,
        datenschutzUrl,
        companyName,
        violationText1,
        violationText2,
        faqURL,
        currency,
        bankDetails,
    };
}
